import { useNotificationActions } from "@/features/Notification";
import { useCallback, useMemo } from "react";

export const useErrorAlert = () => {
  const { topAlert } = useNotificationActions();

  const showErrorAlert = useCallback((error: unknown, defaultMessage = "Произошла ошибка") => {
    let message = defaultMessage;

    if (typeof error === "string") {
      message = error;
    } else if (
      typeof error === "object" &&
      error !== null &&
      "message" in error &&
      typeof error.message === "string"
    ) {
      message = error.message;
    } else if (typeof error === "object" && error !== null) {
      try {
        message = JSON.stringify(error);
      } catch {
        message = defaultMessage;
      }
    }

    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error(error);
    }

    topAlert(message, "error", 2000);
  }, [topAlert]);

  return useMemo(() => ({ showErrorAlert }), [showErrorAlert]);
};
